import { createSelector } from 'reselect';
import createAction from '../createAction.js';
import DuckSelector from '../DuckSelector.js';
import primitiveDuckCreator from './primitiveDuckCreator.js';
import hasStore from './checks/hasPayloadTypeCheck.js';

const legacyReducer = (state, action, duck) => {
    switch (action.type) {
        case duck.types.SET_BOOLEAN: {
            hasStore(duck, action, 'boolean');
            return action.payload;
        }

        case duck.types.SET_TRUE: {
            return true;
        }

        case duck.types.SET_FALSE: {
            return false;
        }

        case duck.types.SET_VALUE: {
            hasStore(duck, action, 'boolean');
            return action.payload;
        }

        case duck.types.TOGGLE_BOOLEAN: {
            return !state;
        }

        default:
            return state;
    }
};

const rtkReducer = (builder, duck) => {
    builder

        .addCase(duck.types.SET_BOOLEAN, (state, action) => {
            hasStore(duck, action, 'boolean');
            return action.payload;
        })

        .addCase(duck.types.SET_TRUE, (state, action) => true)

        .addCase(duck.types.SET_FALSE, (state, action) => false)

        .addCase(duck.types.SET_VALUE, (state, action) => {
            hasStore(duck, action, 'boolean');
            return action.payload;
        })

        .addCase(duck.types.TOGGLE_BOOLEAN, (state, action) => !state);
};

const booleanDuckCreator = (options) =>
    primitiveDuckCreator({
        primitiveState: false,
        ...options,
    }).extend({
        creators: (duck) => ({
            setBoolean: createAction(duck.types.SET_BOOLEAN),
            setTrue: createAction(duck.types.SET_TRUE),
            setFalse: createAction(duck.types.SET_FALSE),
            // setValue is deprecated
            setValue: createAction(duck.types.SET_VALUE),
            toggleBoolean: createAction(duck.types.TOGGLE_BOOLEAN),
        }),
        reducer: options.useRTKReducer ? rtkReducer : legacyReducer,
        selectors: (duck) => ({
            selectIsTrue: new DuckSelector((selectors) =>
                createSelector(
                    selectors.getDuckState,
                    (state) => state === true
                )
            ),
            selectIsFalse: new DuckSelector((selectors) =>
                createSelector(
                    selectors.getDuckState,
                    (state) => state === false
                )
            ),
        }),
        types: [
            'SET_BOOLEAN',
            'SET_TRUE',
            'SET_FALSE',
            'SET_VALUE',
            'TOGGLE_BOOLEAN',
        ],
    });

export { booleanDuckCreator as default };
